import {DefaultEventsMap, DeviceType} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {KeypadInfoElementsView} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsView';
import {IKeypadInfoView} from '@gongxigames/framework/slot/modules/keypadInfo/IKeypadInfoView';
import {
    KeypadInfoElementsViewMobileLandscape
} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsViewMobileLandscape';
import {
    KeypadInfoElementsViewMobilePortrait
} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsViewMobilePortrait';
import {ScreenOrientedView} from '@gongxigames/framework/slot/fragments/module/view';

export class KeypadInfoElementsViewMobile extends ScreenOrientedView<DefaultEventsMap, KeypadInfoElementsView> implements IKeypadInfoView {
    public static readonly NAME: symbol = Symbol('KeypadInfoElementsViewMobile');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected landscapeViewName: symbol = KeypadInfoElementsViewMobileLandscape.NAME;
    protected portraitViewName: symbol = KeypadInfoElementsViewMobilePortrait.NAME;

    public initializeMainGameLayout(): void {
        this._views.forEach((view: KeypadInfoElementsView) => {
            view.initializeMainGameLayout();
        });
    }

    public initializeFreeSpinsLayout(): void {
        this._views.forEach((view: KeypadInfoElementsView) => {
            view.initializeFreeSpinsLayout();
        });
    }

    public refreshBalance(balance: number): void {
        this._views.forEach((view: KeypadInfoElementsView) => {
            view.refreshBalance(balance);
        });
    }

    public refreshPointsBalance(points: number): void {
        this._views.forEach((view: KeypadInfoElementsView) => {
            view.refreshPointsBalance(points);
        });
    }

    public refreshFreeSpinsInfo(freeSpinsLeft: number, freeSpinsTotal: number): void {
        this._views.forEach((view: KeypadInfoElementsView) => {
            view.refreshFreeSpinsInfo(freeSpinsLeft, freeSpinsTotal);
        });
    }

    public refreshTotalBetInfo(totalBetValue: string): void {
        this._views.forEach((view: KeypadInfoElementsView) => {
            view.refreshTotalBetInfo(totalBetValue);
        });
    }

    public refreshLeftTicker(text: string): void {
        this._views.forEach((view: KeypadInfoElementsView) => {
            view.refreshLeftTicker(text);
        });
    }

    public refreshRightTicker(text: string): void {
        this._views.forEach((view: KeypadInfoElementsView) => {
            view.refreshRightTicker(text);
        });
    }
}
